import { envInit, initVConsole } from '@os-web/utils';
import { ErrorReportPlugin, Sense } from '@os-web/report';
import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import 'normalize.css';
import 'vant/es/toast/style';
import './styles/vant-overrides.css';

import App from './App.vue';
import router from './router/index.js';
import { createPinia } from 'pinia';

void Sense.init({
  app_id: '211',
  product_id: '177926476636110248',
  app_version: '海外独立站',
});

const app = createApp(App);

app.use(ElementPlus);
app.use(ErrorReportPlugin);
app.use(router);
app.use(createPinia());

(async () => {
  await initVConsole();
  await envInit({
    channel: 'yqw_xtfn_00008',
  });
  app.mount('#app');
})().catch((error) => {
  console.error('应用初始化失败：', error);
});
